import { connect } from 'react-redux';
import React, { Component } from 'react';

import { closeModalCouponError } from '../../../actions/purchaseActions';

export class ModalCouponError extends Component {
    constructor(props) {
        super(props);
        this.goToSearchPage = this.goToSearchPage.bind(this);
    }

    goToSearchPage() {
        window.history.go(-1);
    }

    render() {
        if (!this.props.isModalCouponError) return <div />;

        return (
            <div className="comp_modalpagamento">
                <div className="modalcontents">
                    <div className="contents">
                        <div className="modaltop">
                            <div className="title">Cupom indisponível</div>

                            <div onClick={this.props.closeModalCouponError} className="close-btn">
                                {' '}
                                &times;{' '}
                            </div>
                        </div>

                        <div className="modalmiddle">
                            <p>
                                <img src="/assets/images/pagamento/alert.svg" alt="erro" />
                            </p>
                            <p>
                                <strong>
                                    O cupom utilizado não é válido para esta compra ou está expirado.
                                </strong>
                            </p>
                            <p>
                                Por favor, volte à tela inicial para realizar uma nova cotação ou ajustar sua escolha sem este cupom.
                            </p>
                        </div>

                        <div className="modalbotton">
                            <button className="button full" onClick={this.goToSearchPage} style={{ marginTop: '10px' }}>
                                <span>Voltar à tela inicial</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => ({
        isModalCouponError: state.purchase.isModalCouponErrorActive,
    }),
    {
        closeModalCouponError,
    }
)(ModalCouponError);


// WEBPACK FOOTER //
// ./src/components/purchase/modal_coupon_error/ModalCouponError.jsx